export enum DataSyncModeEnum {
  POLLING = 'polling',
  STREAMING = 'streaming'
}